import { useCallback } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Tooltip } from "antd";
import { clsx } from "clsx";
import { $getSelection, $isRangeSelection } from "lexical";

import { RVIcon } from "../../../../atoms/RVIcon/RVIcon";

import styles from "./JSONMenuTriggerPlugin.module.scss";

const insertOpeningTag = "{{";

type JSONMenuTriggerPluginProps = {
    tooltip?: string;
    className?: string;
};

export function JSONMenuTriggerPlugin({ className, tooltip }: JSONMenuTriggerPluginProps) {
    const [editor] = useLexicalComposerContext();

    const handleInsertOpeningTag = useCallback(() => {
        editor.focus();
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                $getSelection()?.insertText(insertOpeningTag);
            }
        });
    }, [editor]);

    const icon = <RVIcon onClick={handleInsertOpeningTag} icon="json" className={clsx(styles.jsonIcon, className)} />;

    return tooltip ? <Tooltip title={tooltip}>{icon}</Tooltip> : icon;
}
